import React from 'react';
import packageJson from '../../../../package.json';
import './Version.scss';

interface VersionProps {
  position?: 'top-right' | 'bottom-right' | 'bottom-left' | 'top-left' | 'footer';
  className?: string;
}

const Version: React.FC<VersionProps> = ({ position = 'bottom-right', className }) => {
  const version = packageJson.version;

  return (
    <div className={`version-container ${position} ${className || ''}`}>
      <span className="version-text">v{version}</span>
    </div>
  );
};

export default Version;